import {SignUpCredentials} from '~/shared/store/storeModules/restrictedSharedActions';

export type FormValues = {
  fullName: string;
  email: SignUpCredentials['email'];
  cellPhone: SignUpCredentials['cellPhone'];
  agreeToTerms: SignUpCredentials['agreeToTerms'];
  wantPromotion: SignUpCredentials['wantPromotion'];
};

export const isFormValues = (values: Partial<FormValues>): values is FormValues => {
  return (
    !!values &&
    typeof values === 'object' &&
    typeof values.fullName === 'string' &&
    typeof values.email === 'string' &&
    typeof values.cellPhone === 'string' &&
    typeof values.agreeToTerms === 'boolean' &&
    typeof values.wantPromotion === 'boolean'
  );
};

export type FormValuesWithCodeAndToken = FormValues & {
  authenticationCode?: SignUpCredentials['authenticationCode'];
  authenticationToken?: SignUpCredentials['authenticationToken'];
};

export const isFormValuesWithCodeAndToken = (values: Partial<FormValuesWithCodeAndToken>): values is FormValuesWithCodeAndToken => {
  return (
    (typeof values.authenticationCode === 'undefined' || typeof values.authenticationCode === 'string') &&
    (typeof values.authenticationToken === 'undefined' || typeof values.authenticationToken === 'string') &&
    isFormValues(values)
  );
};
